import { render, staticRenderFns } from "./express-company-add-or-update.vue?vue&type=template&id=b861f7a0"
import script from "./express-company-add-or-update.vue?vue&type=script&lang=js"
export * from "./express-company-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports